import React, { Fragment } from 'react';
import { H4, H6, Image, LI, P, UL } from '../../../AbstractElements';
import { JolioMark, MarkJecno, Comment } from '../../../Constant';
import { CardBody, Col, Media, Row } from 'reactstrap';

const Comments = () => {
  const data = [
    {
      name: JolioMark,
      img: 'comment.jpg',
      work: '( Designer )',
      like: '02 Hits',
      comments: '485 Comments',
      pera: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
      commentReplay: [
        {
          name: MarkJecno,
          img: '9.jpg',
          work: '( Web Devloper )',
          pera: 'The best thing is location and drive through the forest. The resort is 35km from Ramnagar. The gardens are well kept and maintained. Its a good place for relaxation away from the city noise. The staff is very friendly and overall we had a really good & fun time, thanks to staff member - Bhairav, Rajat, Gunanand, Lokesh & everyone else. And also we went for an adventurous night safari and saw barking deers, tuskar elephant.',
        },
      ],
    },

    { name: 'Helly Roi', img: '4.jpg', work: '( Designer )', like: '12 Hits', comments: '598 Comments', pera: 'Clean resort with maintained garden but rooms are average Lack of communication between the staff members. Receptionsit full of attitude. Arrogant staff. Except good view there is nothing great in this property.Resort is 35 kms away from Ramnagar Town.' },
  ];
  return (
    <Fragment>
      <CardBody>
        <H4>{Comment}</H4>
        <UL className='simple-list'>
          {data.map((item, id) => {
            return (
              <Fragment key={id}>
                <LI>
                  <Media className='align-self-center d-md-flex'>
                    <Image className='align-self-center' src={require(`../../../assets/images/blog/${item.img}`)} alt='' />
                    <Media body className='flex-grow-1'>
                      <Row>
                        <Col md='4 xl-100'>
                          <H6 className='mt-0'>
                            {item.name}
                            <span> {item.work}</span>
                          </H6>
                        </Col>
                        <Col md='8 xl-100'>
                          <UL className='simple-list comment-social float-start float-md-end learning-comment'>
                            <LI className='digits'>
                              <i className='icofont icofont-thumbs-up m-0'></i>
                              {item.like}
                            </LI>
                            <LI className='digits'>
                              <i className='icofont icofont-ui-chat m-0'></i>
                              {item.comments}
                            </LI>
                          </UL>
                        </Col>
                      </Row>
                      <P>{item.pera}</P>
                    </Media>
                  </Media>
                </LI>
                {item.commentReplay && (
                  <LI>
                    <UL className='simple-list'>
                      {item.commentReplay.map((item, id) => {
                        return (
                          <LI key={id}>
                            <Media className='align-self-center d-md-flex'>
                              <Image className='align-self-center' src={require(`../../../assets/images/blog/${item.img}`)} alt='' />
                              <Media body className='flex-grow-1'>
                                <Row>
                                  <Col md='4 xl-100'>
                                    <H6 className='mt-0'>
                                      {item.name}
                                      <span> {item.work}</span>
                                    </H6>
                                  </Col>
                                </Row>
                                <P>{item.pera}</P>
                              </Media>
                            </Media>
                          </LI>
                        );
                      })}
                    </UL>
                  </LI>
                )}
              </Fragment>
            );
          })}
        </UL>
      </CardBody>
    </Fragment>
  );
};

export default Comments;
